// Determine status card colors based on practice statuses
const red = `danger`;
const blue = `primary`;
const green = `success`;
const grey = `secondary`;
const warning = `warning`;

const getHeartbeatStyle = (hasRun, hasError) => {
    if (!hasRun) return grey;

    return hasError ? red : green;
};

const getExtractionStyle = (hasRun, hasError, isStale, isActive) => {
    if (!hasRun) return grey;

    if (isActive) return getRunningStyle();

    if (hasError || isStale) return red;

    return green;
};

const getLoaderStyle = (hasRun, hasError, isActive, isPaused = false) => {
    if (!hasRun) return grey;

    // preserves existing priority for every other caller (isActive beats hasError beats green);
    // isPaused only affects callers that actually pass it (currently just Attachment Sync)
    if (isActive) return getRunningStyle();

    if (hasError) return red;

    // paused (e.g. a scheduled sync that hit its window end mid-run) is a distinct,
    // non-error state - only shown when there isn't already a real error to report
    if (isPaused) return warning;

    return green;
};

const getRunningStyle = () => {
    return blue;
};

const getMissionControlStyle = (isMissionControlAlive) => {
    if (isMissionControlAlive === undefined || isMissionControlAlive === null)
        return 'text-secondary';

    if (isMissionControlAlive) {
        return 'text-success';
    }
    return 'text-danger';
};

export {
    getHeartbeatStyle,
    getExtractionStyle,
    getLoaderStyle,
    getRunningStyle,
    getMissionControlStyle,
};
